import React, { Component } from "react";
import $ from "jquery";
import { here_api_key } from "../../utils/mapapi";


class CustomerMap extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.currentDrawObject = {};
        this.drawing = "";
        this.isTap = false;
    }

    componentDidMount() {
        var platform = new window.H.service.Platform({
            apikey: here_api_key,
        });

        let engineType = window.H.Map.EngineType['HARP'];
        // Obtain the default map types from the platform object
        var maptypes = platform.createDefaultLayers({
            engineType: engineType
         });
         let defaultLayer = maptypes.vector.normal.map;

         let map = new window.H.Map(document.getElementById('mapContainer'),
         defaultLayer, {
            engineType: engineType,
            center: { lng: this.props.lng || 13.4, lat: this.props.lat || 52.51 },
            zoom: 3
        });

        window.addEventListener("resize", () => map.getViewPort().resize());

        //Step 3: make the map interactive
        // MapEvents enables the event system
        // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
        new window.H.mapevents.Behavior(
            new window.H.mapevents.MapEvents(map)
        );
        //Zooming
        map.addEventListener("tap", (evt) => {
            if (this.currentDrawObject) {
                console.log("3");
                window.map.removeObject(this.currentDrawObject);
                this.currentDrawObject = {};
            }
            this.isTap = true;
            var coord = window.map.screenToGeo(
                evt.currentPointer.viewportX,
                evt.currentPointer.viewportY
            );
            var marker = new window.H.map.Marker({
                lat: coord.lat,
                lng: coord.lng,
            });
            this.currentDrawObject = marker;
            let coordObj = {
                lat: coord.lat,
                lng: coord.lng,
            };
            this.props.onPositionChange(coordObj);
        });
        window.H.ui.UI.createDefault(map, maptypes);

        //clustering

        window.map = map;

        console.log("this.props.lat", this.props.lat);
        if (this.props.lat && this.props.lng) {
            if (!$.isEmptyObject(this.currentDrawObject)) {
                console.log("1");
                window.map.removeObject(this.currentDrawObject);
                this.currentDrawObject = {};
            }

            var marker = new window.H.map.Marker({
                lat: this.props.lat,
                lng: this.props.lng,
            });

            this.currentDrawObject = marker;
            window.map.addObject(marker);
            window.map.setCenter({ lat: this.props.lat, lng: this.props.lng });
            window.map.setZoom(16);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.lat !== prevProps.lat || this.props.lng !== prevProps.lng) {
            if (this.currentDrawObject && !this.isTap) {
                window.map.removeObject(this.currentDrawObject);
                this.currentDrawObject = {};
            }
            this.isTap = false;

            window.map.setCenter({ lat: this.props.lat, lng: this.props.lng });
            window.map.setZoom(16);

            var marker = new window.H.map.Marker({
                lat: this.props.lat,
                lng: this.props.lng,
            });

            this.currentDrawObject = marker;
            window.map.addObject(marker);
        }
    }

    render() {
        return (
            <React.Fragment>
                <div id="mapContainer"></div>
            </React.Fragment>
        );
    }
}

export default CustomerMap;
